import { useMutation, useQuery, useQueryClient } from "react-query";

import { aircraftAvailabilityApi } from "../../../../api/v3/aircraftAvailabilityApi";
import { unwrapV3ResponseData } from "../../../../api/v3/responseContract";

export const aircraftAvailabilityQueryKeys = {
    root: ["aircraft-availability-windows"],
    list: (aircraftId) => [...aircraftAvailabilityQueryKeys.root, aircraftId],
};

function unwrapData(response) {
    return unwrapV3ResponseData(response);
}

export function useAircraftAvailabilityWindowList(aircraftId, options = {}) {
    return useQuery(
        aircraftAvailabilityQueryKeys.list(aircraftId),
        async () => unwrapData(await aircraftAvailabilityApi.listWindows(aircraftId)),
        {
            enabled: Boolean(aircraftId),
            staleTime: 30 * 1000,
            ...options,
        },
    );
}

export function useAircraftAvailabilityWindowMutations(aircraftId) {
    const queryClient = useQueryClient();
    const invalidate = () => queryClient.invalidateQueries(aircraftAvailabilityQueryKeys.list(aircraftId));

    return {
        createWindow: useMutation((payload) => aircraftAvailabilityApi.createWindow(aircraftId, payload), { onSuccess: invalidate }),
        updateWindow: useMutation(({ windowId, payload }) => aircraftAvailabilityApi.updateWindow(aircraftId, windowId, payload), { onSuccess: invalidate }),
        deleteWindow: useMutation((windowId) => aircraftAvailabilityApi.deleteWindow(aircraftId, windowId), { onSuccess: invalidate }),
        previewBatch: useMutation((payload) => aircraftAvailabilityApi.previewBatch(aircraftId, payload)),
        createBatch: useMutation((payload) => aircraftAvailabilityApi.createBatch(aircraftId, payload), { onSuccess: invalidate }),
    };
}

export default useAircraftAvailabilityWindowMutations;
